import CryptoJS from 'crypto-js';

export const getAwsCredential = (awsCredential) => {
  const bytes = CryptoJS.AES.decrypt(awsCredential, process.env.REACT_APP_CREDENTIAL_DECODE_KEY)
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}
